import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { Autorizacao } from "view/component/Autorizacao/Autorizacao"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { AutorizacaoAction } from "./Autorizacao.action"
import { AutorizacaoActionTypes, AutorizacaoState } from "./Autorizacao.types"


const estadoInicial: AutorizacaoState = {
  estado: EstadoRequisicao.OCIOSO,
  erros: undefined,

  autorizacao: new Autorizacao(),
}


export const autorizacaoReducer: Reducer<AutorizacaoState, AutorizacaoActionTypes> = (state = estadoInicial, action): AutorizacaoState => {
  if (AutorizacaoAction.iniciar.pending.match(action)) {
    return {
      ...state,
      estado: EstadoRequisicao.CARREGANDO,
      autorizacao: new Autorizacao()
    }

  } else if (AutorizacaoAction.iniciar.fulfilled.match(action)) {
    return {
      ...state,
      estado: EstadoRequisicao.BEM_SUCEDIDO,
      autorizacao: new Autorizacao(action.payload.membroUnidade)
    }

  } else if (AutorizacaoAction.iniciar.rejected.match(action)) {
    return {
      ...state,
      estado: EstadoRequisicao.FALHOU,
      erros: action.payload as ResponseError,
    }
  }

  return state;
}
